import PaymentInfoForm from "./payment_info_form"
import { Currency } from "./currency_switcher_modal"

import { saveUserPermissions } from "shared/scripts/new_badge_button"

interface Plan {
  id: string
  amount: number
  interval: "month" | "year"
  interval_count: number
  name: string
  local_price: number
  local_price_formatted: string
  local_price_monthly: number
  local_price_formatted_monthly: string
  currency: string
}

interface SubscriptionProps {
  tier: string
  plan_id: string
  product_id: string
  currency_plans: Record<string, { monthly_plan: Plan; yearly_plan: Plan }>
}

interface Props {
  onClose: () => void
  onUpgrade: () => void
  subscriptionProps: {
    product_id: string
    plan_id: string
    tier: string
    initial_promo_code: string | null
    subscriptions_path: string
    browser_type: string
    create_stripe_customer_url: string
    email: string
    eligible_for_trial: boolean
    currencies: Currency[]
    default_currency: string
    pro: SubscriptionProps
    intermediate_pro: SubscriptionProps
    setup_intent_client_secret?: string | null
    setup_intent_return_url?: string | null
    stripe_customer_preinitialized?: boolean
  }
  target: "intermediate_pro" | "pro"
}

const PurchaseModal = ({ onClose, onUpgrade, subscriptionProps, target }: Props) => {
  const subscription = subscriptionProps[target]

  return (
    <div className="flexbox">
      <PaymentInfoForm
        eligibleForTrial={subscriptionProps["eligible_for_trial"]}
        email={subscriptionProps["email"]}
        initialPromoCode={subscriptionProps["initial_promo_code"]}
        modalButtonType="new"
        currencyPlans={subscription["currency_plans"]}
        defaultCurrency={subscriptionProps["default_currency"]}
        onModalHandleSuccessfulSubscription={() => {
          const isProPlus = subscription["tier"] == "pro"
          const tierName = isProPlus ? "Pro+" : "Pro"
          window.appendFlash(`Upgrade complete. Welcome to IFTTT ${tierName}!`, "success")

          const multiActionPermission =
            subscription["tier"] == "intermediate_pro" ||
            (subscription["tier"] == "pro" && window.App.user.tier == "free")

          saveUserPermissions(subscription["tier"], {
            multi_action: { permitted: multiActionPermission },
            filter_code: { permitted: isProPlus },
            queries: { permitted: isProPlus },
            multi_service_account: { permitted: isProPlus },
          })
          onUpgrade()
          onClose()
        }}
        planId={subscription["plan_id"]}
        productId={subscription["product_id"]}
        referrerPath={window.location.href}
        renderingInsideModal={true}
        setupIntentClientSecret={subscriptionProps["setup_intent_client_secret"]}
        setupIntentReturnUrl={subscriptionProps["setup_intent_return_url"]}
        stripeCustomerPreinitialized={subscriptionProps["stripe_customer_preinitialized"] === true}
        currencies={subscriptionProps["currencies"]}
        tier={subscription["tier"]}
        urls={{
          createStripeCustomerUrl: subscriptionProps["create_stripe_customer_url"],
          subscriptionsPath: subscriptionProps["subscriptions_path"],
          subscriptionSuccessPath: "",
        }}
      />
    </div>
  )
}

export default PurchaseModal
